import React from "react";

const JOKERS = new Set(["JCC", "JSS", "JHH", "JDD"]);

// Reference CasinoResult (cricketv / superover types): t1.score balls grouped per inning and over.
// Each ball: "w" per joker card, then "ww" (wicket) or run minus jokers; red (text-playerb) on wicket/joker.
function buildInnings(score) {
  const team1 = [];
  const team2 = [];
  const totals = { 1: { run: 0, wkt: 0 }, 2: { run: 0, wkt: 0 } };
  (Array.isArray(score) ? score : []).forEach((b) => {
    let jokers = 0;
    const parts = [];
    String(b.card || "").split(",").forEach((c) => {
      if (JOKERS.has(c)) {
        jokers += 1;
        parts.push("w");
      }
    });
    const wkt = b.wkt === true || Number(b.wkt) === 1;
    parts.push(wkt ? "ww" : Number(b.run) - jokers);
    const runclass = wkt || jokers > 0 ? "text-playerb" : "";
    const inning = Number(b.ing) === 1 ? 1 : 2;
    const list = inning === 1 ? team1 : team2;
    const idx = parseInt(b.oc, 10) - 1;
    if (!list[idx]) list[idx] = { run: 0, score: 0, wkt: 0, nat: "", runData: [] };
    totals[inning].run += parseInt(b.run, 10) || 0;
    totals[inning].wkt += wkt ? 1 : 0;
    list[idx].run += parseInt(b.run, 10) || 0;
    list[idx].score = totals[inning].run;
    list[idx].wkt = totals[inning].wkt;
    list[idx].nat = b.nat;
    list[idx].runData.push({ runText: parts.join("+"), runclass });
  });
  return { team1: team1.filter(Boolean), team2: team2.filter(Boolean) };
}

const BALL_HEADS = ["1", "2", "3", "4", "5", "6", "Run/Over", "Score"];

function InningTable({ data, tableClass }) {
  return (
    <table className={tableClass}>
      <thead>
        <tr>
          <th className="text-center">
            <b>
              <span className="text-success">{data[0].nat}</span>
            </b>
          </th>
          {BALL_HEADS.map((h) => (
            <React.Fragment key={h}>
              {" "}
              <th className="text-center">
                <b>{h}</b>
              </th>
            </React.Fragment>
          ))}
        </tr>
      </thead>{" "}
      <tbody>
        {data.map((over, i) => (
          <tr key={i}>
            <td className="text-center">
              <b>Over {i + 1}</b>
            </td>{" "}
            {Array.from({ length: 6 }, (_, j) => (
              <td className="text-center" key={j}>
                {over.runData[j] ? <span className={over.runData[j].runclass}>{over.runData[j].runText}</span> : null}
              </td>
            ))}{" "}
            <td className="text-center nationcard">{over.run}</td>{" "}
            <td className="text-center nationcard">{`${over.score}/${over.wkt}`}</td>
          </tr>
        ))}
      </tbody>
    </table>
  );
}

/** Reference result body (.five-cricket-result) for superover / superover2 / cricketv3. */
export default function FiveCricketResultBody({ t1 }) {
  const { team1, team2 } = buildInnings(t1?.score);
  return (
    <div className="row row5 align-items-center five-cricket-result">
      {team1.length ? (
        <div className="col-12">
          <div className="text-right mt-3 score-head">
            {" Winner: "}
            <span className="text-success">{t1?.winnat}</span>
            {` | ${t1?.rdesc ?? ""} `}
          </div>{" "}
          <h4 className="mb-0">First Inning</h4>{" "}
          <div className="table-responsive mb-0">
            {team1.length > 0 && <InningTable data={team1} tableClass="table table-bordered" />}
          </div>{" "}
          <h4 className="mb-0">Second Inning</h4>{" "}
          <div className="table-responsive">
            {team2.length > 0 && <InningTable data={team2} tableClass="table" />}
          </div>
        </div>
      ) : null}
    </div>
  );
}
